import { setupSwiper } from "../utils/swiper-setup";

document.addEventListener("DOMContentLoaded", () => {
  // TESTIMONIALS
  const testimonialSwipers = document.querySelectorAll(
    ".component__testimonials .swiper",
  );
  testimonialSwipers.forEach((module) => {
    let thisID = module.id;
    const breakpoint = window.matchMedia("(min-width: 992px)");
    let thisSwiper: any;

    thisSwiper = setupSwiper(thisID, {
      spaceBetween: 16,
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 1.5,
        },
      },
      navigation: {
        nextEl: "#" + thisID + "-next",
        prevEl: "#" + thisID + "-prev",
      },
      pagination: {
        el: "#" + thisID + "-pagination",
        clickable: true,
      },
    });
  });

  // PAGE LINKS
  const pageLinkSwipers = document.querySelectorAll(
    ".component__page-links .swiper",
  );
  pageLinkSwipers.forEach((module) => {
    let thisID = module.id;
    const breakpoint = window.matchMedia("(min-width: 992px)");
    let thisSwiper: any;

    const breakpointChanged = () => {
      // console.log(breakpoint.matches);
      if (breakpoint.matches === true) {
        thisSwiper !== undefined && thisSwiper.destroy(true, true);
        return;
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = () => {
      thisSwiper = setupSwiper(thisID, {
        spaceBetween: 16,
        slidesPerView: 1,
        autoHeight: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
        },
        pagination: {
          el: "#" + thisID + "-pagination",
          clickable: true,
        },
      });
    };

    breakpoint.addEventListener("change", breakpointChanged);
    breakpointChanged();
  });

  const containers = document.querySelectorAll<HTMLElement>(
    ".accordion__container",
  );

  containers.forEach((container) => {
    const rows = container.querySelectorAll<HTMLElement>(".accordion__row");

    rows.forEach((row) => {
      const header = row.querySelector<HTMLElement>(".row__header");

      if (!header) return;

      header.addEventListener("click", () => {
        const isOpen = row.classList.contains("is-open");

        rows.forEach((r) => r.classList.remove("is-open"));

        if (!isOpen) row.classList.add("is-open");
      });
    });
  });

  // HERO BANNER
  const heroSwipers = document.querySelectorAll(".component__hero");
  heroSwipers.forEach((module) => {
    let mainId = module.querySelector(".swiper-text .swiper")?.id;
    let imageId = module.querySelector(".swiper-images")?.id;
    let thisSwiper: any;
    let imageSwiper: any;

    if (mainId) {
      thisSwiper = setupSwiper(mainId, {
        allowTouchMove: false,
        autoplay: {
          delay: 7500,
        },
        disableOnInteraction: true,
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        navigation: {
          nextEl: "#" + mainId + "-next",
          prevEl: "#" + mainId + "-prev",
        },
        pagination: {
          el: "." + mainId + "-pagination",
          type: "bullets",
          renderBullet: function (index, className) {
            if (index < 10) {
              return (
                '<span class="' + className + '">0' + (index + 1) + "</span>"
              );
            } else {
              return (
                '<span class="' + className + '">' + (index + 1) + "</span>"
              );
            }
          },
          clickable: true,
        },
      });
    }

    if (imageId) {
      imageSwiper = setupSwiper(imageId, {
        allowTouchMove: false,
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
      });

      if (thisSwiper) {
        thisSwiper.controller.control = imageSwiper;
        imageSwiper.controller.control = thisSwiper;
      }
    }
  });
});
